<template>
  <div
    class="d-flex justify-content-center cursor-pointer"
    v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
    :title="invoiceType"
  >
    <font-awesome-icon icon="clock" />
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: Object
    }
  },
  computed: {
    invoiceType () {
      return this.type ? this.type.type : ''
    }
  }
}
</script>
